import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const SectionHeaderTitle = styled(Typography).attrs({ variant: TextStyles['Heading 5'] })<{
  color?: 'grey' | 'orange';
}>(({ theme, color }) => ({
  color: color === 'grey' ? theme.colors.inactiveBlack : theme.colors.darkOrange,
}));

export const HorizontalSeparator = styled.div<{ color?: 'grey' | 'orange' }>(({ theme, color }) => ({
  borderBottom: `1px solid ${color === 'grey' ? theme.colors.inactiveBlack : theme.colors.darkOrange}`,
  flex: 1,
}));

export const SeparatorWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  flex: 1,

  // use for useScrollToRecentlyAdded
  scrollMarginTop: 134, // 67 + 47 + 20 (HeaderWrapper + ShipmentFiltersWrapper + ShipmentListWrapper)
});
